var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('div',{ref:"gauge",style:({'background-color': _vm.$store.getters.getColorPalette().background2ColorCode, 'max-height':_vm.height, 'max-width':'100%'})})])
}
var staticRenderFns = []

export { render, staticRenderFns }